import React from "react";

export default function CreditCardIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 14 14" fill="none" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1814_6712)">
        <path
          d="M5.59657 9.37915C5.50272 9.37915 5.41098 9.40698 5.33295 9.45912C5.25492 9.51126 5.1941 9.58536 5.15819 9.67206C5.12228 9.75877 5.11288 9.85417 5.13119 9.94622C5.1495 10.0383 5.19469 10.1228 5.26105 10.1892C5.32741 10.2555 5.41195 10.3007 5.504 10.319C5.59604 10.3373 5.69145 10.3279 5.77815 10.292C5.86485 10.2561 5.93896 10.1953 5.9911 10.1173C6.04323 10.0392 6.07106 9.94749 6.07106 9.85365C6.07106 9.7278 6.02107 9.60711 5.93209 9.51813C5.8431 9.42914 5.72241 9.37915 5.59657 9.37915Z"
          fill={filteredStyles.fill}
        />
        <path
          d="M3.70299 9.37915H2.75843C2.63259 9.37915 2.5119 9.42914 2.42291 9.51813C2.33393 9.60711 2.28394 9.7278 2.28394 9.85365C2.28394 9.97949 2.33393 10.1002 2.42291 10.1892C2.5119 10.2782 2.63259 10.3281 2.75843 10.3281H3.70299C3.82883 10.3281 3.94952 10.2782 4.03851 10.1892C4.1275 10.1002 4.17749 9.97949 4.17749 9.85365C4.17749 9.7278 4.1275 9.60711 4.03851 9.51813C3.94952 9.42914 3.82883 9.37915 3.70299 9.37915Z"
          fill={filteredStyles.fill}
        />
        <path
          d="M13.6941 1.7562C13.5627 1.62416 13.4066 1.51936 13.2346 1.44783C13.0626 1.3763 12.8782 1.33943 12.6919 1.33936H1.33948C0.963484 1.34052 0.603221 1.49041 0.33735 1.75628C0.0714789 2.02215 -0.0784038 2.38241 -0.0795733 2.75841V11.2727C-0.0804803 11.4592 -0.0440655 11.6439 0.0275252 11.816C0.0991158 11.9881 0.204434 12.1442 0.337274 12.2749C0.468655 12.407 0.62482 12.5118 0.796806 12.5833C0.968792 12.6549 1.15321 12.6917 1.33948 12.6918H12.6919C13.0679 12.6906 13.4282 12.5407 13.6941 12.2749C13.9599 12.009 14.1098 11.6487 14.111 11.2727V2.75841C14.1109 2.57214 14.074 2.38772 14.0025 2.21574C13.931 2.04375 13.8262 1.88758 13.6941 1.7562ZM1.00689 2.42582C1.05006 2.38118 1.10173 2.34563 1.15885 2.32126C1.21597 2.29689 1.27738 2.28419 1.33948 2.28391H12.6919C12.754 2.28419 12.8154 2.29689 12.8726 2.32126C12.9297 2.34563 12.9813 2.38118 13.0245 2.42582C13.1139 2.51361 13.1649 2.63316 13.1664 2.75841V4.17747H0.864985V2.75841C0.866534 2.63316 0.917544 2.51361 1.00689 2.42582ZM13.0245 11.6053C12.9813 11.65 12.9297 11.6855 12.8726 11.7099C12.8154 11.7343 12.754 11.747 12.6919 11.7472H1.33948C1.21435 11.745 1.09498 11.6942 1.00648 11.6057C0.917983 11.5172 0.867261 11.3979 0.864985 11.2727V5.12202H13.1664V11.2727C13.1661 11.3348 13.1534 11.3963 13.1291 11.4534C13.1047 11.5105 13.0691 11.5622 13.0245 11.6053Z"
          fill={filteredStyles.fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1814_6712">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
